import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Beaker } from "lucide-react";

export default function LabTeaser() {
  return (
    <section
      id="lab-teaser"
      className="chapter relative py-20 md:py-28"
      data-testid="chapter-lab-teaser"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Link
          to="/lab"
          data-cursor="magnetic"
          data-testid="home-lab-link"
          className="group block relative rounded-[24px] overflow-hidden border-2 border-ink dark:border-white/20 p-8 md:p-12 lg:p-16 bg-[#FFF5DC] dark:bg-[#161B22] shadow-none dark:shadow-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 90% 110%, rgba(255,107,53,0.18), transparent 40%), radial-gradient(circle at 10% -10%, rgba(167,139,250,0.18), transparent 40%)",
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center"
          >
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ink text-paper font-mono text-[10px] tracking-[0.22em] uppercase font-semibold mb-6">
                <Beaker size={12} strokeWidth={2.5} />
                Bonus · 06 — The Lab
              </span>
              <h2 className="font-serif text-[40px] md:text-[60px] lg:text-[76px] leading-[1.0] tracking-tight text-ink">
                Things I'm{" "}
                <span className="italic relative inline-block">
                  playing
                  <svg
                    className="absolute -bottom-1.5 left-0 w-full h-3 text-[#FF6B35]"
                    viewBox="0 0 200 12"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M2 8 Q 50 -2, 100 6 T 198 7"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      fill="none"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>{" "}
                with.
              </h2>
              <p className="mt-6 max-w-[52ch] text-mute leading-[1.65] text-[15.5px] md:text-[17px]">
                Tools, agents, songs and processes from my builders' bench. Some
                shipped, some playthings — all are excuses to learn.
              </p>
              <div className="mt-8 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-ink text-paper font-mono text-[11px] tracking-[0.22em] uppercase group-hover:bg-ink-soft transition-colors">
                Open The Lab
                <ArrowUpRight
                  size={14}
                  strokeWidth={2.4}
                  className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </div>
            </div>

            <div className="lg:col-span-5 grid grid-cols-3 gap-3 md:gap-4 [transform:rotate(-1deg)]">
              {[
                { label: "TOOL", color: "#FFD7C2", border: "#FF6B35" },
                { label: "AGENT", color: "#C8F0DC", border: "#00B589" },
                { label: "MUSIC", color: "#E6D8FF", border: "#8B5CF6" },
                { label: "NOTE", color: "#FFF1A6", border: "#C99A00" },
                { label: "TOOL", color: "#C8D6FF", border: "#3856DA" },
                { label: "AGENT", color: "#FFD7C2", border: "#FF6B35" },
              ].map((c, i) => (
                <div
                  key={i}
                  className="aspect-square rounded-[14px] border-2 border-[#1A1A1A]/75 shadow-[3px_3px_0_0_rgba(26,26,26,0.75)] flex items-end p-3 font-mono text-[10px] tracking-[0.22em] uppercase font-semibold text-[#1A1A1A]/65"
                  style={{
                    background: c.color,
                    transform: `rotate(${(i % 2 === 0 ? -1 : 1) * (1 + (i % 3))}deg)`,
                  }}
                >
                  {c.label}
                </div>
              ))}
            </div>
          </motion.div>
        </Link>
      </div>
    </section>
  );
}
